import uuid from 'uuid/v4'
import { updateIntegrations } from './template.reducer'

export function duplicateTemplate(template) {
  const templateCopy = JSON.parse(JSON.stringify(template))

  const mapOfRealIdsToFakeIds = {}
  delete templateCopy.id
  templateCopy.uuid = uuid()
  templateCopy.name = `Duplicate of ${templateCopy.name}`
  templateCopy.template_fields.forEach(tf => {
    // something here sucks.
    delete tf.template_id
    mapOfRealIdsToFakeIds[tf.id] = `TEMP_${tf.id}`
    tf.id = mapOfRealIdsToFakeIds[tf.id]

    tf.list_columns = []

    tf.transformation && delete tf.transformation.id
    tf.validation && delete tf.validation.id
    tf.list_governance && delete tf.list_governance.id
    tf.list_governance && delete tf.list_governance.governable_id
    // for now we have to delete the concatenation_governance because it requires a save first.
    if (tf.concatenation_governance) {
      tf.governance_type = null
      tf.concatenation_governance = null
      // tf.concatenation_governance = {concatenation_governance_patterns: [], tf_id: null, separator: null, type: "" }
    }
    // same with autofill
    if (tf.autofill && tf.governance_type !== 'link') {
      tf.governance_type = null
      tf.autofill = null
      // tf.autofill = {tf_id: null, governable_id: null, governable_type: "", id: null}
    }
    tf.date && delete tf.date.id

    if (tf.governance_type === 'cv_id') {
      tf.field_id = 'TEMP_CVID'
      tf.field.id = 'TEMP_CVID'
    }

    if (tf.governance_type === 'link') {
      delete tf.autofill
      delete tf.field.id
      tf.field.id = 'TEMP_link'
      delete tf.field.link_governance.id
      delete tf.field.link_governance.field_id
      delete tf.field_id
      tf.field_id = 'TEMP_link'
      tf.field.link_governance.domain_restrictions.forEach(dr => {
        delete dr.id
        delete dr.link_governance_id
      })
    }
  })
  templateCopy.parameters.forEach(param => {
    param.fieldId = param.template_field?.field.id
    delete param.id
    param.id = `TEMP_${uuid()}`
    if (param.template_field) {
      param.template_field.id = mapOfRealIdsToFakeIds[param.template_field_id]
      param.template_field_id = mapOfRealIdsToFakeIds[param.template_field_id]
    }
    delete param.template_id
  })
  templateCopy.fieldsets.forEach(fs => {
    fs.pivot.template_id = null
  })
  templateCopy.integrations = createDuplicateIntegrations(template)
  // vm.setTemplateState(template)

  // TODO: probably need to figure out how to tackle validation v2 items
  templateCopy.link_validations.forEach(lv => {
    delete lv.uuid
  })
  // as well as potetially the output configurations ETC.
  return templateCopy
}

function createDuplicateIntegrations(template) {
  const fieldsById = template.template_fields.reduce((acc, tf) => {
    acc[tf.field_id] = tf.field
    return acc
  }, {})

  return template.integrations.map(assignedIntegration => {
    const assignedIntegrationCopy = {
      ...assignedIntegration,
      assignedIntegrationId: `TEMP_${uuid()}`,
      id: `TEMP_${uuid()}`,
      configHash: null,
      assignedEntityId: null,
      isDuplicate: true,
    }

    if ('included_output_fields' in assignedIntegration) {
      const outputFields = JSON.parse(assignedIntegration.included_output_fields).map(field => {
        if (fieldsById?.[field?.id]?.governance_type === 'cv_id') {
          return {
            ...field,
            id: 'TEMP_CVID',
            replace_with_governance_type: 'cv_id',
          }
        }

        return field
      })

      assignedIntegrationCopy.included_output_fields = JSON.stringify(outputFields)
    }

    return assignedIntegrationCopy
  })
}

export function isCreativeClassificationActive({
  creativeConfiguration = [],
  template_fields = [],
}) {
  if (creativeConfiguration?.length > 0) return true

  return template_fields?.some(
    tf => tf?.governance_type === 'creative' || tf?.field?.governance_type === 'creative',
  )
}

/**
 * Updates the integrations state based on the provided data.
 *
 * @param {Object} params
 * @param {Object} params.state - The current state.
 * @param {Object} params.integrations - The new integrations data.
 * @param {boolean} params.triggerUserChangedData - Whether to set `hasUserChangedData` to true.
 * @returns {Object} The updated state.
 */
export function updateIntegrationsState({ state, integrations, triggerUserChangedData }) {
  const newIntegrations = Array.isArray(integrations) ? integrations : Object.values(integrations)

  const newIntegrationsById = updateIntegrations(
    state.fieldsById,
    newIntegrations.reduce((acc, int) => ({ ...acc, [int.id]: int }), {}),
    state.templateFieldsById,
  )

  if (
    state.integrations.find(i => i.slug === 'branch') &&
    !newIntegrations.find(i => i.slug === 'branch')
  ) {
    const templateFieldsById = {}
    const templateFields = []
    Object.values(state.templateFieldsById)
      .filter(f => f.governance_type !== 'deep-link')
      .forEach(f => {
        templateFieldsById[f.id] = f
        templateFields.push(f.id)
      })
    return {
      ...state,
      integrations: Object.values(newIntegrationsById),
      integrationsById: newIntegrationsById,
      templateFieldsById,
      hasUserChangedData: triggerUserChangedData,
      templateFields,
    }
  }

  return {
    ...state,
    integrations: Object.values(newIntegrationsById),
    integrationsById: newIntegrationsById,
    hasUserChangedData: triggerUserChangedData || state.hasUserChangedData,
  }
}
